import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import $ from 'jquery';
import {FormattedMessage} from "react-intl";

import {
  toggleSelectionWindow, setCameFromPage, setQtActiveCategory, changeActivePartRelatedItemIndex
} from "../../actions/actionFunctions";
import Analytics from './../../analytics';
import {getCurrentLayout} from "../appLayout";
import ProjectScopeFunctions from '../projectScope/projectScopeFunctions';

class MobileMenu extends ProjectScopeFunctions {

  static propTypes = {
    smallButton: PropTypes.bool,
    smallButtonClassName: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      showRelatedItems: false,
      showSubNav: false
    };
  }

  componentWillUnmount() {
    $(document).off('click', this.handleMobileBlur);
  }

  handleItemClick = (bvDataPart) => {
    Analytics.sendClickEvent("mobile-menu-item");
    const layout = getCurrentLayout();
    if(bvDataPart === "Return to Website") {
      this.setState({showSubNav: true});
    } else {
      $(document).off('click', this.handleMobileBlur);
      if (layout.qtCategories) {
        const qtCategory = layout.qtCategories.find(qtCategory => qtCategory.name === bvDataPart);
        this.goToMaterialsPageCommon(qtCategory.subParts[0].part, bvDataPart);
      } else {
        this.goToMaterialsPageCommon(layout.parts[bvDataPart].subParts(false)[0].part, bvDataPart);
      }
    }
  };

  handleBack = () => {
    if(this.state.showSubNav) {
      this.setState({showSubNav: false});
    } else {
      this.handleToggleDropdown();
    }
  };

  handleToggleDropdown = () => {
    Analytics.sendClickEvent("mobile-menu-toggle-" + (this.state.toggle ? 'show': 'hide'));
    this.setState({
      toggle: !this.state.toggle,
      showSubNav: false
    }, () => {
      this.state.toggle
        ? $(document).on('click', this.handleMobileBlur)
        : $(document).off('click', this.handleMobileBlur)
    })
  };

  handleMobileBlur = (e) => {
    const navClick = e.target.closest('[class*="mobmenu"]');
    const backButtonClick = e.target.closest('.ui-back');
    if (!navClick && !backButtonClick) {
      this.handleToggleDropdown();
    }
  };

  getMenuItems = () => {
    const layout = getCurrentLayout();
    if (!layout) {
      return []
    }
    // if (this.props.mobileNav && this.props.mobileNav.length > 0 && window.location.href.includes("materials")) {
    //   return ["Return to Website"]
    // }
    let menu = (layout.qtCategories)
      ? layout.qtCategories.map(qtCategory => qtCategory.name)
      : [...this.props.layoutParts]
    if (this.props.mobileNav && this.props.mobileNav.length > 0) {
      menu.unshift(
        "Return to Website"
      );
    }
    return menu
  };

  render() {

    const menuItems = this.getMenuItems();

    return menuItems.length ? (
      <div className="mobmenu">
        {this.props.smallButton ? (
          <button className={this.props.smallButtonClassName || "materials-button materials-button--home "}
                  onClick={this.handleToggleDropdown}>
            <span className="materials-button__text"><FormattedMessage id="homeButton.main"/></span>
          </button>
        ) : (
          <button className="mobmenu-button" onClick={this.handleToggleDropdown}>
            <span className="mobmenu-button__line mobmenu-button__line--first"/>
            <span className="mobmenu-button__line mobmenu-button__line--second"/>
            <span className="mobmenu-button__line mobmenu-button__line--third"/>
          </button>
        )}
        <div className={"mobmenu-dropdown" + (this.state.toggle ? " mobmenu-dropdown--opened" : "")}>
          <div className="mobmenu-dropdown__header">
            <button className="ui-back" onClick={this.handleBack}>
              <FormattedMessage id="mobileMenu.backButton"/>
            </button>
          </div>
          {this.props.mobileNav && this.props.mobileNav.length > 0 ?
          <nav className={"mobmenu-dropdown__body-sub" + (this.state.showSubNav ? " mobmenu-dropdown__body-sub--active" : "")}>
            <ul className="mobmenu-dropdown__list">
              {this.props.mobileNav.map((mobileNav, index) => {
                return (
                  <li className={"mobmenu-dropdown__list-item bold"}
                      key={"mobileNav"+index} data-index={index}>
                      <a href={mobileNav.url} target="_blank" rel="noopener noreferrer">{mobileNav.name}</a>
                  </li>
                )
              })}
            </ul>
          </nav>
          : null }
          <nav className={"mobmenu-dropdown__body" + (this.state.showSubNav ? " mobmenu-dropdown__body-sub--active" : "")}>
            <ul className="mobmenu-dropdown__list">
              {menuItems.map((bvDataPart, index) => {
                return (
                  <li className={"mobmenu-dropdown__list-item bold icon--active--white icon--"+bvDataPart.toLowerCase().replace(/\s/g, "-")}
                      key={"nav"+index} data-index={index} onClick={() => this.handleItemClick(bvDataPart)}>
                    {bvDataPart}
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>
    ) : null
  }
}

const mapStateToProps = (store) => {
  return {
    layoutParts: store.stepsState.layoutParts,
    mobileNav: store.navigationState.mobileNav
  };
};

export default connect(mapStateToProps, {
  toggleSelectionWindow,
  setCameFromPage,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex
})(MobileMenu);
